import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import {
  BardoBootstrapService,
  temEstabelecimentoNaSessao,
} from '@nomoh-monorepo/data-access-bardo-administrador';
import { AuthService } from '@nomoh-monorepo/data-access-auth';
import { NotificacaoService } from '@nomoh-monorepo/data-access-shared-notificacao';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { EtapaEstabelecimentoComponent } from '../etapa-estabelecimento/etapa-estabelecimento.component';

/**
 * Primeiro acesso mínimo: apenas cadastro do estabelecimento.
 * Tipos/serviços/profissionais ficam no SetupOperacionalModal (sob demanda).
 */
@Component({
  selector: 'lib-primeiro-acesso',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    EtapaEstabelecimentoComponent,
    TranslateModule,
  ],
  templateUrl: './primeiro-acesso.component.html',
  styleUrls: ['./primeiro-acesso.component.scss'],
})
export class PrimeiroAcessoComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private bardoBootstrap = inject(BardoBootstrapService);
  private notificacaoService = inject(NotificacaoService);
  private authService = inject(AuthService);
  private translateService = inject(TranslateService);

  finalizando = signal(false);

  ngOnInit(): void {
    document.body.classList.add('n-primeiro-acesso-page');
    void this.verificarEstabelecimento();
  }

  ngOnDestroy(): void {
    document.body.classList.remove('n-primeiro-acesso-page');
  }

  private async verificarEstabelecimento(): Promise<void> {
    if (!this.authService.$sessionVerified()) {
      await this.authService.checkSession();
    }

    if (
      temEstabelecimentoNaSessao(
        this.authService.$bardoContextoAtivo(),
        this.authService.$user()?.id
      )
    ) {
      await this.finalizarConfiguracao(false);
    }
  }

  async onEstabelecimentoSalvo(): Promise<void> {
    await this.finalizarConfiguracao(true);
  }

  async finalizarConfiguracao(mostrarSucesso: boolean): Promise<void> {
    if (this.finalizando()) {
      return;
    }

    this.finalizando.set(true);
    try {
      await this.authService.refreshToken();
      this.bardoBootstrap.inicializar(true);

      if (mostrarSucesso) {
        this.notificacaoService.notificacaoSuccess(
          this.translateService.instant('PRIMEIRO_ACESSO.NOTIFICACAO_SUCESSO')
        );
      }

      await this.router.navigateByUrl('/agenda');
    } catch (error) {
      console.error('Erro ao finalizar primeiro acesso', error);
      this.notificacaoService.notificacaoError(
        this.translateService.instant('PRIMEIRO_ACESSO.NOTIFICACAO_ERRO_FINALIZAR')
      );
    } finally {
      this.finalizando.set(false);
    }
  }

  navegarHome(): void {
    this.router.navigateByUrl('/dashboard');
  }
}
